'use client';

import { useEffect, useRef } from 'react';
import { Container } from '@/components/layout/container/container';
import cn from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './html-block.module.scss';

export type HtmlBlockProps = {
  content: string;
  className?: string;
} & HTMLAttributes<HTMLElement>;

export const HtmlBlock = ({ content, className, ...props }: HtmlBlockProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current || !content) return;

    containerRef.current.innerHTML = '';

    const wrapper = document.createElement('div');
    wrapper.innerHTML = content;
    containerRef.current.appendChild(wrapper);

    const tpWidget = containerRef.current.querySelector('.trustpilot-widget');
    if (tpWidget && window.Trustpilot) {
      window.Trustpilot.loadFromElement(tpWidget, true);
    }
  }, [content]);

  return (
    <section className={cn(styles.component, className)} {...props}>
      <Container>
        <div ref={containerRef} className={styles.component__content} suppressHydrationWarning />
      </Container>
    </section>
  );
};
